// // ========== IMPORTS ==========
// import React from 'react';
// import LandingPowerContentsBorderImage from '../../assets/images/ARISE WEBSITE_microsite-18.png';
// import LandingPowerArrowImage from '../../assets/images/ARISE WEBSITE_microsite-19.png';
// import LandingPowerRightArrow from '../../assets/images/Right.svg';
// import '../../assets/styles/Poweredby.css'; // You'll need to update this CSS file as well

// // Logos
// import LandingPowerArise4uLogo from '../../assets/images/arise.png';
// import LandingPowerHCLTechLogo from '../../assets/images/Hcl.svg';
// import LandingPowerCareerShaperLogo from '../../assets/images/career.svg';
// import LandingPowerPearsonLogo from '../../assets/images/pearson.svg';
// import LandingPowerMeitylogo from '../../assets/images/meity.svg';

// // ========== COMPONENT ==========
// const PoweredBy = () => {
//   // ========== RENDER ==========
//   return (
//     <section className='landing-power-section'>
//       <div className='landing-power-custom-padding'>
//         <div className='landing-power-container pt-5'>
//           <div className='landing-power-title-box mt-3 d-flex justify-content-center align-items-center'>
//             <article className='landing-power-font-bold landing-power-text-start landing-power-fs-1 landing-power-mb-0'>Powered By </article>
       
 
//           </div>
//                      <p className='justify-content-center align-items-center text-center'>Organizations shaping the future of technology, careers, and entrepreneurship</p>
//           <div className='landing-power-title-box-two d-flex justify-content-center align-items-center'>
//             <div className='landing-power-img-box w-100'>
//               <img src={LandingPowerContentsBorderImage} alt='Contents Border Image' className='landing-power-border-image' />
//             </div>
//           </div>

//           <div className='landing-power-carousel d-flex text-center w-100 mt-3'>
//             <div className='landing-power-col-14-4'>
//               <div className='landing-power-card border-0 p-3'>
//                 <div className='landing-power-logo-container d-flex justify-content-center align-items-center'>
//                   <img src={LandingPowerHCLTechLogo} alt='HCLTech Logo' className='landing-power-logo' />
//                 </div>
//               </div>
//             </div>

//             <div className='landing-power-col-14-4'>
//               <div className='landing-power-card border-0 p-3'>
//                 <div className='landing-power-logo-container d-flex justify-content-center align-items-center'>
//                   <img src={LandingPowerCareerShaperLogo} alt='Career Shaper Logo' className='landing-power-logo' />
//                 </div>
//               </div>
//             </div>

//             <div className='landing-power-col-14-4'>
//               <div className='landing-power-card border-0 p-3'>
//                 <div className='landing-power-logo-container d-flex justify-content-center align-items-center'>
//                   <img src={LandingPowerPearsonLogo} alt='Pearson Logo' className='landing-power-logo' />
//                 </div>
//               </div>
//             </div>

//             <div className='landing-power-col-14-4'>
//               <div className='landing-power-card border-0 p-3'>
//                 <div className='landing-power-logo-container d-flex justify-content-center align-items-center'>
//                   <img src={LandingPowerMeitylogo} alt='MeitY Startup Hub Logo' className='landing-power-logo' />
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className='landing-power-btn-box d-flex justify-content-center align-items-center py-5 mb-5'>
//             {/* You can add a button here if needed, with landing-power- prefix */}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default PoweredBy;




// ========== IMPORTS ==========
import React from 'react';
import LandingPowerContentsBorderImage from '../../assets/images/ARISE WEBSITE_microsite-18.png';
import '../../assets/styles/Poweredby.css';

// Logos
import LandingPowerHCLTechLogo from '../../assets/images/Hcl.svg';
import LandingPowerCareerShaperLogo from '../../assets/images/career.svg';
import LandingPowerPearsonLogo from '../../assets/images/pearson.svg';
import LandingPowerMeitylogo from '../../assets/images/meity.svg';

// ========== COMPONENT ==========
const PoweredBy = () => {
  return (
    <section className='landing-power-section'>
      <div className='landing-power-custom-padding'>
        <div className='landing-power-container pt-5'>
          
          {/* Title */}
          <div className='landing-power-title-box mt-3 d-flex justify-content-center align-items-center'>
            <article className='landing-power-font-bold landing-power-text-start landing-power-fs-1 landing-power-mb-0'>
              Powered By
            </article>
          </div>

          {/* Subtitle */}
          <p className='justify-content-center align-items-center text-center'>
            Organizations shaping the future of technology, careers, and entrepreneurship
          </p>

          {/* Border Image */}
          <div className='landing-power-title-box-two d-flex justify-content-center align-items-center'>
            <div className='landing-power-img-box w-100'>
              <img 
                src={LandingPowerContentsBorderImage} 
                alt='Contents Border Image' 
                className='landing-power-border-image' 
              />
            </div>
          </div>

          {/* Logos Row */}
          <div className='landing-power-carousel mt-4'>
            <div className='landing-power-card'>
              <img src={LandingPowerHCLTechLogo} alt='HCLTech Logo' className='landing-power-logo' />
            </div>
            <div className='landing-power-card'>
              <img src={LandingPowerCareerShaperLogo} alt='Career Shaper Logo' className='landing-power-logo' />
            </div>
            <div className='landing-power-card'>
              <img src={LandingPowerPearsonLogo} alt='Pearson Logo' className='landing-power-logo' />
            </div>
            <div className='landing-power-card'>
              <img src={LandingPowerMeitylogo} alt='MeitY Logo' className='landing-power-logo' />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default PoweredBy;
